var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOccurMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.4375C20 9.28125 19.5486 10.0195 18.8542 10.4062V15.75C18.8542 16.1016 18.6111 16.875 17.7431 16.875C17.5 16.875 17.2569 16.8047 17.0833 16.6289L14.0972 14.2383C12.6389 13.043 10.7639 12.375 8.88889 12.375H7.88194C7.8125 12.7617 7.74306 13.1133 7.74306 13.5C7.74306 14.5547 8.09028 15.4688 8.64583 16.2422C9.20139 16.9805 8.64583 18 7.74306 18H5.17361C4.75694 18 4.375 17.7891 4.20139 17.4023C3.61111 16.2422 3.29861 14.9062 3.29861 13.5C3.29861 13.1484 3.33333 12.7617 3.36806 12.375H2.22222C0.972222 12.375 0 11.3906 0 10.125V6.75C0 5.51953 0.972222 4.5 2.22222 4.5H8.88889C10.7639 4.5 12.6389 3.86719 14.0972 2.67188L17.0833 0.28125C17.2569 0.105469 17.5 0 17.7778 0C18.6458 0 18.8889 0.84375 18.8889 1.16016V6.50391C19.5486 6.89062 20 7.62891 20 8.4375ZM16.6667 13.4297V3.48047L15.4861 4.42969C13.6111 5.94141 11.2847 6.75 8.88889 6.75V10.125C11.2847 10.125 13.6111 10.9688 15.4861 12.4805L16.6667 13.4297Z",
    fill: "#AAAAAA",
    fillOpacity: 0.933333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccurMenuIcon);
export default __webpack_public_path__ + "static/media/occur-menu-icon.bab8b894d89f607366d76452453a2ead.svg";
export { ForwardRef as ReactComponent };